import React from 'react'
import {useTranslation} from 'react-i18next'

import {BaseSwitchInput} from './BaseSwitchInput'

type IsPossibleToCleanPumpOnSiteInputProps = Omit<
  React.ComponentProps<typeof BaseSwitchInput>,
  'title' | 'testId'
>

export const IsPossibleToCleanPumpOnSiteInput: React.FC<IsPossibleToCleanPumpOnSiteInputProps> = (
  props
) => {
  const {t} = useTranslation()

  return (
    <BaseSwitchInput
      title={t(
        'orderIntake.rmc.steps.unloading.pumpConfiguration.canCleanPumpOnSite',
        'Is it possible to clean the pump on site?'
      )}
      testId="clean-pump-switch"
      {...props}
    />
  )
}
